/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductDesignCollection
 */
export interface MelcoFusionModelsCustomProductDesignCollection {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductDesignCollection
     */
    id?: string | null;
}

export function MelcoFusionModelsCustomProductDesignCollectionFromJSON(json: any): MelcoFusionModelsCustomProductDesignCollection {
    return MelcoFusionModelsCustomProductDesignCollectionFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductDesignCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductDesignCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function MelcoFusionModelsCustomProductDesignCollectionToJSON(value?: MelcoFusionModelsCustomProductDesignCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


